import ServiceAssignmentRulesAllComponent from './service_assignment_rules.all.component';

let ServiceAssignmentRulesAllModule = angular.module('serviceAssignmentRulesAll', [
])

    .component('serviceAssignmentRulesAll', ServiceAssignmentRulesAllComponent)
    .name;

export default ServiceAssignmentRulesAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/all/index.js